import { appPath } from '@fs/zion-config'
import useMarkdownContent from '../../../hooks/useMarkdownContent'

type UseTrainingMarkdownContentResult = {
  markdown: string
  error: string | null
  loading: boolean
  locales: string[]
  selectedLocale: string | null
  setSelectedLocale: (locale: string) => void
}

export default function useTrainingMarkdownContent(baseFilename: string): UseTrainingMarkdownContentResult {
  return useMarkdownContent(
    baseFilename,
    `${appPath}/place-editor-training/directory/`,
    `${appPath}/place-editor-training/content`
  )
}
